export default __webpack_public_path__ + "static/media/about-image-03.189f28df.svg";